import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbSidebarModule, NbToastrModule, NbTimepickerModule, NbMenuModule } from '@nebular/theme';

import { BaseModule } from './base/base.module';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UnauthInterceptorService } from './core/auth/unauth-interceptor.service';
import { DgMenuModule } from './common/menu/menu.module';
import { TestPreviewComponent } from './modules/test-preview/test-preview.component';
import { ErrorPageComponent } from './modules/error-page/error-page.component';


@NgModule({
  declarations: [AppComponent, TestPreviewComponent, ErrorPageComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    NbLayoutModule,
    NbThemeModule.forRoot({ name: 'default' }),
    DgMenuModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbToastrModule.forRoot(),
    NbTimepickerModule.forRoot({
      localization: {
        hoursText: 'ساعت',
        minutesText: 'دقیقه',
        secondsText: 'ثانیه',
        ampmText: 'صبح/ظهر',
      }
    }),
    BaseModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthInterceptorService,
      multi: true,
    },
    // { provide: LOCALE_ID, useValue: 'fa-IR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }